import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { SsoInterface } from 'src/app/util/interfaces/sso';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ToolSsoService {
	private postSsoURL = environment.baseApiUrl + 'sso/createSSO';
	private updateSsoURL = environment.baseApiUrl + 'sso/updateSSO/{hash}';
	private searchSsoURL = environment.baseApiUrl + 'sso/searchSSO';
	private deleteSsoURL = environment.baseApiUrl + 'sso/deleteSSO/{hash}';

	constructor(
		private httpClient: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	postSSO(form: SsoInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = {
			customer_name: form.customer_name,
			customer_domain: form.customer_domain.trim(),
			customer_page: form.customer_page.trim(),
			logout_page: form.logout_page.trim(),
			redirect_page: form.redirect_page.trim(),
		};

		return this.httpClient.post(this.postSsoURL, body, { headers: headers });
	}

	updateSSO(formUpdate: SsoInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		const updateSsoURL = this.updateSsoURL.replace('{hash}', formUpdate.customer_hash);
		const body = {
			customer_name: formUpdate.customer_name,
			customer_domain: formUpdate.customer_domain.trim(),
			customer_page: formUpdate.customer_page.trim(),
			logout_page: formUpdate.logout_page.trim(),
			redirect_page: formUpdate.redirect_page.trim(),
			customer_hash: formUpdate.customer_hash,
		};

		return this.httpClient.put(updateSsoURL, body, { headers: headers });
	}

	getAllSSO(): Observable<SsoInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.httpClient.get<any[]>(this.searchSsoURL, { headers: headers });
	}

	deleteSSO(hash: SsoInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const deleteSsoURL = this.deleteSsoURL.replace('{hash}', hash.customer_hash);

		return this.httpClient.delete(deleteSsoURL, { headers: headers });
	}
}
